export default __webpack_public_path__ + "static/media/tar1.30c66eab.PNG";